import { useQuery } from '@tanstack/react-query';

import type { InsuranceV3GetCarriersByStateResponse } from '@/api/generated';
import { insuranceV3GetCarriersByStateOptions } from '@/api/generated/@tanstack/react-query.gen';
import { stateNames } from '@/lib/zipcode.ts';
import { type InsuranceCarrier, parseCarrierType } from '@/types/insurance.type';

export function useGetLegacyInsuranceCarriersQuery(state: string | null | undefined) {
  return useQuery({
    ...insuranceV3GetCarriersByStateOptions({ path: { state: state ?? '' } }),
    enabled: state != null && Object.hasOwn(stateNames, state.toUpperCase()),
    select: transformToInsuranceCarriers,
  });
}

const transformToInsuranceCarriers = (
  data: InsuranceV3GetCarriersByStateResponse
): InsuranceCarrier[] => {
  return data
    .filter((insurance) => !insurance.is_other)
    .flatMap((insurance): InsuranceCarrier[] =>
      [...new Set(insurance.carrier_types.flatMap((type) => parseCarrierType(type) ?? []))].map(
        (type) => ({
          internalId: `${insurance.uuid}-${type}`,
          uuid: insurance.uuid,
          name: insurance.name,
          state: insurance.state,
          carrierType: type,
          displayName: insurance.display_name,
          templateUuid: insurance.template_uuid ?? '',
          isOther: false,
        })
      )
    )
    .sort((a, b) => a.displayName.localeCompare(b.displayName));
};
